import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { INLINES } from '@contentful/rich-text-types';
import ExpandIcon from '@square-icons/react/24/UI/chevron-down';
import { MarketLink } from '@market/react';
import {
  ShopAccordion,
  ShopAccordionSummary,
  ShopAccordionDetails,
} from 'components/common/shop_accordion';
import RichTextContent from 'components/common/contentful/rich_text_content';
import ProductHeading from 'components/pages/product/product_heading';
import InStockOptions from './backordered/in_stock_options';
import RetailOptions from './backordered/retail_options';
import NotifyMe from './backordered/notify_me';

const useStyles = makeStyles((theme) => ({
  accordionTitle: {
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '-0.4px',
    fontWeight: theme.type.fontWeight.medium,
  },
}));

const SECTION_CONTENT_TYPES = {
  PRODUCT_ALTERNATIVE: 'shopAccordionProductAlternativeContent',
  RETAIL: 'shopAccordionRetailProductContent',
  CONTENT: 'shopAccordionContent',
};

const Backordered = (props) => {
  const { currentProduct, backordered, setFinancingModalOpen } = props;

  const classes = useStyles();

  const renderNode = {
    // eslint-disable-next-line react/no-unstable-nested-components
    [INLINES.EMBEDDED_ENTRY]: (node) => (
      <Box
        component="a"
        display="inline-block"
        mr={1}
        mt={1}
        href={node.data.target.url}
        key={node.data.target.title}
      >
        <img
          src={node.data.target.image_url}
          style={{ verticalAlign: 'bottom' }}
        />
      </Box>
    ),
    // eslint-disable-next-line react/no-unstable-nested-components
    [INLINES.HYPERLINK]: (node, children) => (
      <MarketLink href={node.data.uri} target="_blank" rel="noreferrer">
        {children}
      </MarketLink>
    ),
  };

  const renderDetails = (content_type, content) => {
    switch (content_type) {
      case SECTION_CONTENT_TYPES.PRODUCT_ALTERNATIVE: {
        return <InStockOptions content={content} />;
      }
      case SECTION_CONTENT_TYPES.RETAIL: {
        return (
          <RetailOptions
            disclaimer={content.disclaimer}
            retailOptions={content.retail_options}
          />
        );
      }
      case SECTION_CONTENT_TYPES.CONTENT: {
        return (
          <RichTextContent content={content} rendererOptions={{ renderNode }} />
        );
      }
      default: {
        return null;
      }
    }
  };

  return (
    <>
      <ProductHeading
        currentProduct={currentProduct}
        backorderedHeading={backordered.heading}
        onFinancingTriggerClick={() => setFinancingModalOpen(true)}
      />
      {backordered.show_email_form && (
        <Box mt={5}>
          <NotifyMe
            slug={currentProduct.slug}
            title={backordered.email_form_title}
          />
        </Box>
      )}
      <Box mt={5}>
        {backordered.accordion_sections.map(
          ({ title, content, content_type }, idx) => (
            <ShopAccordion key={idx} defaultExpanded={idx === 0}>
              <ShopAccordionSummary
                classes={{ content: classes.accordionTitle }}
                expandIcon={<ExpandIcon />}
              >
                {title}
              </ShopAccordionSummary>
              <ShopAccordionDetails>
                {renderDetails(content_type, content)}
              </ShopAccordionDetails>
            </ShopAccordion>
          ),
        )}
      </Box>
    </>
  );
};

export default Backordered;
